import styled from "@emotion/styled";
import { FormControlLabel, FormGroup, Grid2 } from "@mui/material";

import { Button } from "../../../../../../../components/ui/Button/Button";

const FormWrapper = styled.form`
  width: 100%;
  will-change: content;
`;

const SearchButton = styled(Button)`
  padding: 0;
`;

const BoxButton = styled.div`
  padding-left: 0;
  padding-top: ${p => p.theme.space[4]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.lgMin}) {
    padding-left: ${p => p.theme.space[4]}px;
  }

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMin}) {
    padding-top: 0;
  }
`;

const GridItem = styled(Grid2)`
  margin-top: ${p => p.theme.space[3]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-top: ${p => p.theme.space[4]}px;
  }
`;

const FormGroupStyled = styled(FormGroup)`
  justify-content: flex-start;
  row-gap: 20px;
  column-gap: 26px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    justify-content: center;
    row-gap: ${p => p.theme.space[7]}px;
    column-gap: ${p => p.theme.space[7]}px;
  }
`;

const FormControlLabelStyled = styled(FormControlLabel)`
  margin-left: 0;
  margin-right: 0;

  & .MuiTypography-root {
    font-size: 14px;

    @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      font-size: ${p => p.theme.space[5]}px;
    }
  }
`;

export {
  FormWrapper,
  GridItem,
  BoxButton,
  FormGroupStyled,
  FormControlLabelStyled,
  SearchButton,
};
